import { Component } from 'react'
import { Col, Row } from 'reactstrap'
import TablePreferencePicker from '../Material/TablePreferencePicker'

class LiabilityClaimActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    <a id="toggleLiabilityClaimColumnPickerButton" className="driver-list-button" onClick={() => this.toggleModal("viewColumnPicker")}>
                        PREFERENCE | <i className="fa fa-table" aria-hidden="true"></i>
                    </a>
                    {this.state.openModal === "viewColumnPicker" &&
                        <TablePreferencePicker
                            columnConfig={this.props.columnConfig}
                            currentUser={this.props.currentUser}
                            open={this.state.openModal === "viewColumnPicker"}
                            target="toggleLiabilityClaimColumnPickerButton"
                            setColumns={this.props.setColumns}
                            refetchPreferences={this.props.refetchPreferences}
                            preferenceType={"liability_claim"}
                        />
                    }
                </Col>
            </Row>
        )
    }
}

export default (LiabilityClaimActions)
